module.exports = __webpack_public_path__ + "img/d4211b1.svg";